<app-add-category [viewTitle]="title" [parentIdValue]="parentCaregory"></app-add-category>
